import axios from 'axios'
import config from 'Config'

const instance = axios.create({
  baseURL: config.api.getUrl(),
  withCredentials: true,
  headers: { 'content-type': 'application/json' }
})

export default instance
